module.exports = __webpack_public_path__ + "img/download.a9010e69.svg";